export const YASITE_TIER_NAMES = {
  recent: '近期第 0-19 天（06:00 前加昨天，10 分钟）',
  midterm: '中期第 20-59 天（每小时）',
  forward: '远期第 60-89 天（每 6 小时）',
  batch_up: '有房酒店批量上架',
  maintenance: '目录与清理维护',
}

export function canUpYaSiteHotel(row = {}) {
  return Number(row.is_up) === 1 &&
    Number(row.state) === 2 &&
    Number(row.book_flag) === 1 &&
    Number(row.is_have_room_status) === 1 &&
    Number(row.is_system_up) === 0
}

export function yaSiteRuntimeSummary(runtime = {}, producer = {}) {
  if (runtime.overall_healthy && producer.overall_healthy) {
    return 'PHP 同步生产者、Go 资源 Worker 与订单状态/同步监控 Task 调度器均正常运行'
  }
  const missing = []
  if (!producer.overall_healthy) missing.push('PHP 同步生产者存在缺失或超时')
  if (!runtime.worker_healthy) missing.push('Go 资源 Worker 无有效心跳')
  if (!runtime.task_scheduler_healthy) missing.push('Go Task 调度器无有效心跳（订单状态轮询与同步告警不会执行）')
  return missing.length ? missing.join('；') : '尚未取得运行状态，请刷新后确认'
}
